import React, { useState } from 'react'

export default function PasswordComponent({fieldName, hasHelperText, isSameAs, register, patternRules, label,error_msg,isReq}) {
    const [showPassword, setShowPassword] = useState()
  return (
    <div className="form-group col-md-12 ">
        <label htmlFor='password'>{label}</label>
        <div className="input-group mb-3">
            <input 
            style={{borderRight: '0px solid transparent'}}
                type={showPassword ? 'text' :'password'}
                className="form-control"
                {...register(`${fieldName}`, {
                        required: {
                            value: isReq,
                            message: '*this field is required'
                        },
                         pattern: {
                            
                            value: patternRules === 'password' ? 
                            /^(?=.*[A-Z])(?=.*\d)(?=.*[@^$!%*?&])[A-Za-z\d@^$!%*?&]{8,}$/i : '',
                            message: 'invalid input'
                        },
                        validate: (fieldValue)=>{
                            if (isSameAs){
                            return(
                                fieldValue === isSameAs || "Passwords does not match"
                            )
                            }
                        }
                    })
                    }
            />
            <div className="input-group-append">
                <span
                 onClick={()=>setShowPassword(!showPassword)} className={`input-group-text bg-transparent ${!showPassword ? 'mdi mdi-eye-outline' : 'mdi mdi-eye-off-outline'}`}></span>
            </div>
        </div>
        {
          error_msg &&
          <div className="text-danger small mt-1">
            {error_msg}
          </div>
        }
        {
          (!error_msg && hasHelperText) &&
          <span style={{fontSize: '0.815rem'}} className="mt-2 d-block">Note: Password 
          must be at least 8 character long and include at least 1 Upper case, 
          1 Digit, and 1 special character (@^$!%*?&)</span>
        }
    </div>    
  )
}
